import { useEffect } from 'react';
import { EmployeeService } from 'src/api/EmployeeService';
import { useParams } from 'react-router';
import { useApiCall } from '../apiCall';
import { invalidateEmployee, invalidateEmployees } from '@stores/employeeStore';

const useDeleteEmployee = (
    employeeId?: string,
): {
    isEmployeeDeleted: true | undefined;
    isDeletingEmployee: boolean;
    deleteEmployeeError: string | undefined;
    deleteEmployee: () => void;
} => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const {
        response: isEmployeeDeleted,
        isLoading: isDeletingEmployee,
        error: deleteEmployeeError,
        requestApiCall: deleteEmployee,
    } = useApiCall(
        EmployeeService.deleteEmployee,
        [departmentId, employeeId],
        [departmentId, employeeId],
        false,
    );

    /*
     * A successful delete invalidates the cached employee data so the
     * cache never serves the deleted employee. Mounted list consumers
     * refresh through their requestApiCall (refresh bypasses the ttl).
     */
    useEffect(() => {
        if (isEmployeeDeleted && departmentId) {
            invalidateEmployees(departmentId);

            if (employeeId) {
                invalidateEmployee(departmentId, employeeId);
            }
        }
    }, [isEmployeeDeleted, departmentId, employeeId]);

    return {
        isEmployeeDeleted,
        isDeletingEmployee,
        deleteEmployeeError,
        deleteEmployee,
    };
};

export default useDeleteEmployee;
